import request from './base/api';

export function fetchBranches(cb, errCb) {
  return request({
    url: 'branchs',
    method: 'get',
    cb,
    errCb
  });
}

export function fetchBranchSchedules({ date, branchId }, cb, errCb) {
  const config = {
    params: {
      date,
      branchId
    }
  };

  return request({
    url: 'branch/schedules',
    method: 'get',
    cb,
    errCb,
    config
  });
}

export default {
  fetchBranches,
  fetchBranchSchedules
};
